import Comfort from 'helpers/Comfort'

const fromTemperature = temp => (
  fromComfort(Comfort.fromTemperature(temp))
)

const fromComfort = comfort => {
  switch (comfort) {
    case Comfort.cold:
      return Color.blue
    case Comfort.cozy:
      return Color.green
    case Comfort.warm:
      return Color.orange
    case Comfort.hot:
      return Color.red
    default:
      return Color.gray
  }
}

const Color = {
  fromTemperature,
  fromComfort,

  blue: '#00ace3',
  green: '#77b53e',
  orange: '#ff8d28',
  red: '#ff001c',
  white: '#ffffff',
  black: '#000000',
  darkGray: '#464444',
  gray: 'rgba(150, 150, 150, 0.75)',
  lightGray: '#ededed',
  lighterGray: '#f2f2f2',
  lightGreen: '#abce8c',
}

export default Color



// WEBPACK FOOTER //
// ./src/helpers/Color.js